import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentLanguage: 'en',
  selectedLanguages: [], // Store the selected languages for the current school
  defaultLanguageCode: 'en', // Store the default language code for the school
  allLanguages: [], // Store all available languages
  currentSchoolId: null, // Track current school context
  currentSubdomain: null // Track current subdomain context
};

export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.currentLanguage = action.payload;
    },
    setSelectedLanguages: (state, action) => {
      // Ensure payload is always an array
      state.selectedLanguages = Array.isArray(action.payload) ? action.payload : [];
    },
    setDefaultLanguageCode: (state, action) => {
      // Use payload or fallback to 'en'
      state.defaultLanguageCode = action.payload || 'en';
    },
    setAllLanguages: (state, action) => {
      state.allLanguages = action.payload;
    },
    setCurrentSchool: (state, action) => {
      console.log('Redux: Setting current school to', action.payload);
      state.currentSchoolId = action.payload;
    },
    setCurrentSubdomain: (state, action) => {
      state.currentSubdomain = action.payload;
    }
  }
});

export const { 
  setLanguage, 
  setSelectedLanguages, 
  setDefaultLanguageCode,
  setAllLanguages, 
  setCurrentSchool, 
  setCurrentSubdomain 
} = languageSlice.actions;

export default languageSlice.reducer; 